export default __webpack_public_path__ + "static/media/014_photo.a7c8a260.jpg";